import Hero from "@/components/Hero";
import PromoBanner from "@/components/PromoBanner";
import Producto from "@/components/Producto";
import Marquee from "@/components/Marquee";
import Carta from "@/components/Carta";
import Locales from "@/components/Locales";
import Nosotros from "@/components/Nosotros";
import Universo from "@/components/Universo";
import Social from "@/components/Social";
import Delivery from "@/components/Delivery";
import CrocClub from "@/components/CrocClub";
import Contacto from "@/components/Contacto";

const Home = () => (
  <main>
    <PromoBanner />
    <Hero />
    <Producto />
    <Marquee />
    <Nosotros />
    <Carta />
    <Universo />
    <Locales />
    <Delivery />
    <Social />
    <CrocClub />
    <Contacto />
  </main>
);

export default Home;
